import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent, interval, merge, Observable } from 'rxjs';
import { distinctUntilChanged, map, mapTo, startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ConnectivityService {
    private readonly _enLinea$ = new BehaviorSubject<boolean>(
    typeof window !== 'undefined' ? navigator.onLine : true
  );
  readonly online$: Observable<boolean> = this._enLinea$.asObservable();

  private readonly msConsulta = 2000;

  constructor(private zone: NgZone) {
    if (typeof window === 'undefined') return;

    this.zone.run(() => this._enLinea$.next(navigator.onLine));

    const eventosOnline$ = merge(
      fromEvent(window, 'online').pipe(mapTo(true)),
      fromEvent(window, 'offline').pipe(mapTo(false))
    ).pipe(startWith(navigator.onLine), distinctUntilChanged());

    const sondeoOnline$ = interval(this.msConsulta).pipe(
      map(() => navigator.onLine),
      distinctUntilChanged()
    );

    const navegadorEnLinea$ = merge(eventosOnline$, sondeoOnline$).pipe(distinctUntilChanged());

    // Actualiza el estado solo en base en el navegador
    navegadorEnLinea$
      .pipe(distinctUntilChanged())
      .subscribe((isOnline) => {
        this.zone.run(() => this._enLinea$.next(!!isOnline));
      });
  }
}
